/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudInfragraph20250507ListNodeInventoryResponseFromJSON, HashicorpCloudInfragraph20250507QueryGraphBodyToJSON, HashicorpCloudInfragraph20250507QueryGraphResponseFromJSON, } from '../models';
/**
 *
 */
export class GraphQueryServiceApi extends runtime.BaseAPI {
    /**
     * ListNodeInventory queries the graph for an aggregate count of nodes per resource type.
     */
    async graphQueryServiceListNodeInventoryRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling graphQueryServiceListNodeInventory.');
        }
        const queryParameters = {};
        if (requestParameters.locationProjectId !== undefined) {
            queryParameters['location.project_id'] = requestParameters.locationProjectId;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/infragraph/2025-05-07/organizations/{location.organization_id}/inventory`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudInfragraph20250507ListNodeInventoryResponseFromJSON(jsonValue));
    }
    /**
     * ListNodeInventory queries the graph for an aggregate count of nodes per resource type.
     */
    async graphQueryServiceListNodeInventory(locationOrganizationId, locationProjectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.graphQueryServiceListNodeInventoryRaw({ locationOrganizationId: locationOrganizationId, locationProjectId: locationProjectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * QueryGraph queries the graph for a specified traversal and returns a list of Nodes and a list of Edges and query metadata.
     */
    async graphQueryServiceQueryGraphRaw(requestParameters) {
        if (requestParameters.locationOrganizationId === null || requestParameters.locationOrganizationId === undefined) {
            throw new runtime.RequiredError('locationOrganizationId', 'Required parameter requestParameters.locationOrganizationId was null or undefined when calling graphQueryServiceQueryGraph.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling graphQueryServiceQueryGraph.');
        }
        const queryParameters = {};
        if (requestParameters.locationProjectId !== undefined) {
            queryParameters['location.project_id'] = requestParameters.locationProjectId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/infragraph/2025-05-07/organizations/{location.organization_id}/query`.replace(`{${"location.organization_id"}}`, encodeURIComponent(String(requestParameters.locationOrganizationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudInfragraph20250507QueryGraphBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudInfragraph20250507QueryGraphResponseFromJSON(jsonValue));
    }
    /**
     * QueryGraph queries the graph for a specified traversal and returns a list of Nodes and a list of Edges and query metadata.
     */
    async graphQueryServiceQueryGraph(locationOrganizationId, body, locationProjectId) {
        const response = await this.graphQueryServiceQueryGraphRaw({ locationOrganizationId: locationOrganizationId, body: body, locationProjectId: locationProjectId });
        return await response.value();
    }
}
